import Vue from "vue";
import Vuex, { Payload } from "vuex";
import VuexPersistence from "vuex-persist";
import businessPlan from "./businessPlan";
import authModule from "./auth";
import attributeModule from "./attribute";
import catalogModule from "./catalog";
import itemModule from "./item";
import accessrule from "./accessrule";
import partnerModule from "./partner";
import portfolioModule from "./portfolio";
import contactUsEnquiryModule from "./contactUsEnquiry";
import roleModule from "./role";
import permissionModule from "./permission";
import tenantModule from "./tenant";
import faqModule from "./faq";
import servicerequestModule from "./servicerequest";
import orderModule from "./order";
import notificationModule from "./notification";
import advertisementModule from "./advertisement";
import inventoryModule from "./inventory";
import passwordResetModule from "./passwordReset";
import taxcodeModule from "./taxcode";
import couponModule from "./coupon";
import customerModule from "./customer";
import profileUpdateModule from "./profileUpdate";
import subscriptionPlanModule from "./subscriptionplan";
import deliveryModule from "./delivery";
import invoiceModule from "./invoice";
import subscriptionModule from "./subscriptions";
import walletstatementModule from "./walletStatement";
import serviceTicketModule from "./serviceticket";
import commissionModule from "./commission";
import paymentModule from "./partnerpayment";
import customerManagement from "./customerManagement";
import tenantProfile from "./tenantProfile";
import emailTemplateModule from "./emailtemplate";
import smsTemplateModule from "./smstemplate";
import whatsappTemplateModule from "./whatsapptemplate";
import inappTemplateModule from "./inapptemplate";
import bulkNotificationModule from "./bulkNotification";
import approvalNotificationBulkModule from "./approvalNotificationBulk";
import featureModule from "./feature";
import Resources from "./currency";
import concern from "./concern";
import profile from "./profile";
import privacySetting from "./privacySetting";
import unit from "./unit";
import onboardCustomer from "./onboardCustomer";
import survey from "./survey";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  modules: [
    "partner",
    "portfolio",
    "contactUsEnquiry",
    "item",
    "subscription",
    "walletstatement",
    "serviceticket",
    "invoice",
    "advertisement",
  ],
  key: "nipige-state",
});

export const store = new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    attribute: attributeModule,
    catalog: catalogModule,
    item: itemModule,
    partner: partnerModule,
    portfolio: portfolioModule,
    contactUsEnquiry: contactUsEnquiryModule,
    role: roleModule,
    permission: permissionModule,
    tenant: tenantModule,
    faq: faqModule,
    delivery: deliveryModule,
    servicerequest: servicerequestModule,
    auth: authModule,
    order: orderModule,
    notification: notificationModule,
    inventory: inventoryModule,
    passwordReset: passwordResetModule,
    taxcode: taxcodeModule,
    coupon: couponModule,
    customer: customerModule,
    profileUpdate: profileUpdateModule,
    subscriptionplan: subscriptionPlanModule,
    invoice: invoiceModule,
    subscription: subscriptionModule,
    walletstatement: walletstatementModule,
    serviceticket: serviceTicketModule,
    commission: commissionModule,
    payment: paymentModule,
    tenantProfile,
    currency: Resources,
    concern: concern,
    customerManagement: customerManagement,
    emailTemplate: emailTemplateModule,
    smsTemplate: smsTemplateModule,
    whatsappTemplate: whatsappTemplateModule,
    inappTemplate: inappTemplateModule,
    bulkNotification: bulkNotificationModule,
    approvalNotificationBulk: approvalNotificationBulkModule,
    feature: featureModule,
    businessPlan,
    profile,
    accessrule,
    advertisement: advertisementModule,
    privacySetting,
    unit,
    onboardCustomer,
    survey,
  },
});
